<!-- my-loader.component.html -->

<div class="loader-image" [hidden]="!loading" style="background: #f7faf9a1!important;">
    <img src="assets/img/loader/tennis-loader.gif" alt="" class="loader-gif">

</div>
<!-- <div class="loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div> -->